export default __webpack_public_path__ + "static/media/samuel-curriculo.1af68fc4.pdf";